import React, { useEffect } from "react";

import { getCarrierMetadata } from "../../../Common/InsuranceEligibility/carrierMetadata";
import {
  VerifyInsuranceAccepted,
  VerifyInsuranceDeclined,
} from "../../../../component-library/VerifyInsurance";
import { VerifyInsuranceNotConfigured } from "../../../../component-library/VerifyInsurance/VerifyInsuranceNotConfigured";
import { VerifyInsurancePending } from "../../../../component-library/VerifyInsurance/VerifyInsurancePending";

const MOCK_CARRIER_NAME = "Other";

const Eligibility = (props) => {
  const { accountData, insuranceEligibilityResponse, nextStep, prevStep } = props;
  const insuranceInfo = { ...accountData.primary_insurance };
  const { carrier } = insuranceInfo;
  const carrierMetadata = getCarrierMetadata(
    carrier === MOCK_CARRIER_NAME ? insuranceEligibilityResponse.payer_name : carrier,
  );
  const { logo: carrierLogo, url: carrierUrl } = carrierMetadata;

  useEffect(() => {
    if (!insuranceEligibilityResponse && accountData.interested_in_guardianship) {
      nextStep(true);
    }
  }, []);

  if (!insuranceEligibilityResponse && accountData.interested_in_guardianship) {
    return <></>;
  }

  return (
    <>
      {insuranceEligibilityResponse["status"] === "accepted" && (
        <>
          <VerifyInsuranceAccepted
            copayAmount={insuranceEligibilityResponse["copay"]}
            insuranceLogo={carrierLogo}
            insuranceName={carrier}
            onClick={nextStep}
            planName={insuranceEligibilityResponse["plan"]}
            title="Great news – you’re covered!"
          />
        </>
      )}
      {insuranceEligibilityResponse["status"] === "declined" && (
        <>
          <VerifyInsuranceDeclined
            insuranceName={carrier}
            insuranceURL={carrierUrl}
            planName={insuranceEligibilityResponse["plan"]}
            prevStep={prevStep}
            title="Unfortunately, your insurance does not cover aptihealth’s services."
          />
        </>
      )}
      {insuranceEligibilityResponse["status"] === "not_configured" && (
        <>
          <VerifyInsuranceNotConfigured
            insuranceName={carrier}
            onClick={nextStep}
            planName={insuranceEligibilityResponse["plan"]}
            title="Your insurance still needs to be confirmed."
          />
        </>
      )}
      {insuranceEligibilityResponse["status"] === "pending" && (
        <>
          <VerifyInsurancePending
            insuranceName={carrier}
            onClick={nextStep}
            planName={insuranceEligibilityResponse["plan"]}
            title={
              <>
                Oh no!
                <br />
                Something went wrong.
              </>
            }
          />
        </>
      )}
    </>
  );
};

export default Eligibility;
